const queryKeys = {
  client: {
    appUI: 'client_app_ui',
    logger: 'client_logger',
    auth: 'client_auth',
    // user: 'client_user',
    // wizard: 'client_wizard'
  },
  server: {
    appSetting: 'server_app_setting',
    userProfile: 'server_user_profile',
    userSetting: 'server_user_setting',
    userList: 'server_user_listing',
    menuMgt: 'server_menumgt',
    customerInfo: 'server_customer_info',
    // account: 'server_account',
    // cheque_account: 'server_cheque_account',
    // transaction_cat: 'server_trans_cat',
    // transaction_type: 'server_trans_type',
    // transaction_company: 'server_trans_company',
    // transaction_cart: 'server_trans_cart',
    // transaction_cart_payment: 'server_trans_cart_payment',
    // transaction_cart_receipt: 'server_trans_cart_receipt',
    // transaction_outstanding: 'server_trans_outstanding',
    // calendar_lunar: 'server_calendar_lunar',
    // entry_lastentrynames: 'server_congreation_lastentrynames',
    // relationship: 'server_relationship',
    // descendent: 'server_descendent',
    // adoption_item_query: 'server_adoption_query',
    // print_profile_list: 'server_print_profile_list',
    // reports: 'server_reports',
    // appCodeByType: 'server_app_code_by_type',
    appContent: 'server_app_content',
    // running_number: 'sever_running_number',
    // currency: 'sever_currency',
    myProperty: 'server_my_property',
    landlordLease: 'server_landlord_lease',
    subPlans: 'sever_subscription_plans',
    leaseDetail: 'server_lease_detail'
  }
};

export default queryKeys;